import { Component, Input, OnInit } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import {RxComponent} from '../../../../../../core/components/common/rx.component';

@Component({
    selector: 'itpx-validity-period-form',
    templateUrl: './validity-period-form.component.html',
    styleUrls: ['./validity-period-form.component.css']
})
export class ValidityPeriodFormComponent extends RxComponent implements OnInit {
    @Input() data: any;
    private initialValue: string;
    private initAgreeValue: boolean;
    private previousValue: number;

    constructor(private modalService: SmartModalService) {
        super()
    }

    ngOnInit() {
        this.initialValue = this.data.form.get('validityPeriod').value;
        this.initAgreeValue = this.data.form.get('agree').value;
        this.previousValue = +this.initialValue;
        if (this.initAgreeValue) {
            this.data.form.get('validityPeriod').disable({ onlySelf: true, emitEvent: false });
        }

        this.data.form.get('agree').valueChanges
            .bindToLifecycle(this)
            .subscribe(value => {
                const validityValue = +this.data.form.get('validityPeriod').value;
                if (value) {
                    this.previousValue = validityValue || 1;
                    this.data.form.get('validityPeriod').disable({ onlySelf: true, emitEvent: false });
                    return;
                }
                if (validityValue <= 0 && this.previousValue) {
                    this.data.form.get('validityPeriod').setValue(this.previousValue, { onlySelf: true, emitEvent: false });
                }
                this.data.form.get('validityPeriod').enable({ onlySelf: true, emitEvent: false });
            });
        this.data.form.get('validityPeriod').valueChanges
            .bindToLifecycle(this)
            .subscribe(value => {
                if (value <= 0) {
                    this.data.form.get('agree').setValue(true, { onlySelf: true, emitEvent: false });
                    this.data.form.get('validityPeriod').disable({ onlySelf: true, emitEvent: false });
                    return;
                }
                this.previousValue = value;
            });
    }

    get isTouched() {
        if (this.data.form.get('agree').value !== this.initAgreeValue) {
            return true;
        }
        if (this.data.form.get('validityPeriod').value !== this.initialValue && !this.data.form.get('agree').value) {
            return true;
        }
        return false;
    }

    onCancel() {
        this.data.form.patchValue({ validityPeriod: this.initialValue, agree: this.initAgreeValue })
        this.modalService.close();
    }

    onSubmit() {
        let response = this.data.form.getRawValue();
        this.modalService.sendResult({
            agree: response.agree,
            validityPeriod: response.agree ? null : response.validityPeriod,
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/details/validity-period-form/validity-period-form.component.ts